export const isEditable = basket => {
  if (!basket) return false;
  const cutoff = basket.editingCutoff;
  if (!cutoff) return false;

  const cutoffMs = Date.parse(cutoff);
  if (Number.isNaN(cutoffMs)) return false;
  return Date.now() < cutoffMs;
};
